import { useTheme } from "../../../../../theme";

export default function Lbl({ children, style: s }) {
  const t = useTheme();
  return (
    <span style={{
      fontFamily: "'DM Mono', monospace", fontSize: 12, letterSpacing: "0.14em",
      textTransform: "uppercase", color: t.textLow, fontWeight: 500,
      whiteSpace: "nowrap", flexShrink: 0, display: "block", ...s,
    }}>{children}</span>
  );
}
